import HttpService from "../services/Http.Service";

async function getPeopleCountLog(data) {
    return await HttpService.controlServerWithToken("GET", "people_count", "get_people_count_log", data);
}

async function getCurrentCount(data) {
    return await HttpService.controlServerWithToken("GET", "people_count", "get_current_count", data);
}

async function getCumulativeCount(data) {
    return await HttpService.controlServerWithToken("GET", "people_count", "get_cumulative_count", data);
}

async function addPeopleCount(data) {
    return await HttpService.controlServerWithToken("POST", "people_count", "add_people_count", data);
}

export { getPeopleCountLog, getCurrentCount, getCumulativeCount, addPeopleCount };
